import React from "react";
import Divider from "@mui/material/Divider";

import VectorArchived from "../../../styles/svg/Vector-archived.svg";
import Vector from "../../../styles/svg/Vector.svg";
import AccordionNav from "./Accordion";
import CreateBoard from "./CreateBoard";
import MyTask from "../../myTask";
import { useBoardListState } from "../hooks/useBoardListState";

function BoardList({ boards }) {
  const {
    expanded,
    includeAdminSections,
    userBoards,
    allBoards,
    archivedBoards,
    handleAccordionChange,
  } = useBoardListState(boards);
  const boardsAccordionChange = React.useMemo(
    () => handleAccordionChange("panel1"),
    [handleAccordionChange]
  );
  const archivedBoardsAccordionChange = React.useMemo(
    () => handleAccordionChange("panel2"),
    [handleAccordionChange]
  );
  const allBoardsAccordionChange = React.useMemo(
    () => handleAccordionChange("panel3"),
    [handleAccordionChange]
  );

  return (
    <>
      <div
        className={`sidebar-board-list ${
          includeAdminSections
            ? "sidebar-board-list-for-create-button"
            : "sidebar-board-list-for-not-create-button"
        }`}
      >
        <MyTask />

        <Divider />
        <AccordionNav
          expanded={expanded.includes("panel1") || expanded === "allPanel"}
          onChange={boardsAccordionChange}
          heading={"Boards"}
          icon={Vector}
          listing={userBoards}
          defaultExpanded={true}
          sx={{
            marginBottm: "0px",
          }}
          uniqueKey={"active-projects"}
          isBoardSearch={true}
        />
        {includeAdminSections ? (
          <>
            <Divider />
            <AccordionNav
              expanded={expanded.includes("panel3") || expanded === "allPanel"}
              onChange={allBoardsAccordionChange}
              heading={"All Boards"}
              icon={Vector}
              listing={allBoards}
              defaultExpanded={true}
              sx={{
                marginBottm: "0px",
              }}
              uniqueKey={"active-projects"}
            />
          </>
        ) : (
          ""
        )}
        <Divider />
        {
          includeAdminSections &&   <AccordionNav
          expanded={expanded.includes("panel2") || expanded === "allPanel"}
          onChange={archivedBoardsAccordionChange}
          heading={"Archived Boards"}
          icon={VectorArchived}
          listing={archivedBoards}
          uniqueKey={"inactive-projects"}
        />
        }
      </div>
      {includeAdminSections && <CreateBoard />}
    </>
  );
}

export default BoardList;
